import { render, staticRenderFns } from "./Packing.vue?vue&type=template&id=90769838&scoped=true"
import script from "./Packing.vue?vue&type=script&lang=js"
export * from "./Packing.vue?vue&type=script&lang=js"
import style0 from "./Packing.vue?vue&type=style&index=0&id=90769838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90769838",
  null
  
)

export default component.exports